<template>

  <b-overlay :show="loading">
    <b-row class="mt-3">

      <b-col>
        <b-card 
          no-body
          header-bg-variant="info"
          header-text-variant="white"
          header="Общая статистика звонков"
        >

          <b-list-group flush v-if="stats && phones">
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Всего номеров <strong class="float-right">{{ phones.length }}</strong>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Всего звонков <strong class="float-right">{{ stats.incoming }}</strong>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Номеров колл-трекинга <strong class="float-right">{{ trackingCount }}</strong>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Звонков на колл-трекинг <strong class="float-right">{{ stats.tracking_calls }}</strong>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Доля звонков на колл-трекинг <strong class="float-right">{{ 100 * formatRate(stats.tracking_share) }}%</strong>
            </b-list-group-item>
          </b-list-group>
          
        </b-card>

        <b-card 
          no-body
          class="mt-3"
          header="Статистика номеров"
        >
          <b-table
            class="px-3"
            responsive="md"
            small
            :items="phones"
            :fields="statCols"
          >
            <template v-slot:cell(tracking_enabled)="data">
              <span v-if="data.item.tracking_enabled" v-b-tooltip.hover title="Call-tracking">
                <fa-icon icon="dot-circle" />
              </span>
            </template>

            <template v-slot:cell(phone)="data">
              {{ formatPhone(data.item.phone) }}
            </template>
          </b-table>
        </b-card>
      </b-col>


      <b-col>

        <b-card no-body class="py-2">
          <b-card-body>
            <b-form-group>
              <b-form-radio-group
                id="btn-charttype"
                v-model="chartType"
                :options="[{text: 'Номера', value: 'phones'}, {text: 'Call-tracking', value: 'call-tracking'}, {text: 'Доля call-tracking', value: 'call-tracking-share'}]"
                buttons
                button-variant="outline-secondary"
                size="sm"
                name="timechartype"
              ></b-form-radio-group>
            </b-form-group>
          </b-card-body>

          <pie-chart
            v-if="stats"
            :height="null"
            :width="null"
            :chartData="chartData"
            :options="chartOptions"/>
        </b-card>

        <b-card no-body class="py-2 mt-3">
          <b-overlay :show="loadingTime">

            <b-card-body>
              <b-form-group>
                <b-form-radio-group
                  id="btn-timecharttype"
                  v-model="timeChartType"
                  :options="[{text: 'Номера', value: 'phones'}, {text: 'Общее', value: 'all'}]"
                  buttons
                  button-variant="outline-secondary"
                  size="sm"
                  name="timecharttype"
                ></b-form-radio-group>
              </b-form-group>
            </b-card-body>

            <line-chart
              v-if="timeStat"
              :height="null"
              :width="null"
              :chartData="timeChartData"
              :options="timeChartOptions"/>
          </b-overlay>
        </b-card>

      </b-col>

    </b-row>
  </b-overlay>

</template>

<script>
import Api from '@/lib/Api';
import Utils from '@/lib/Utils';
import PieChart from '@/components/PieChart';
import LineChart from '@/components/LineChart';
import chroma from 'chroma-js';


export default {
    name: 'StatisticsIncoming',
    components: {
        PieChart,
        LineChart
    },
    props: [
        'projectId',
    ],
    data () {
        return {
            loading: false,
            loadingTime: false,
            phones: [],
            stats: {},
            timeStat: [],
            chartType: 'phones',
            timeChartType: 'phones',
            chartOptions: {
                legend: {position: 'bottom'},
            },
            timeChartOptions: {
                legend: {position: 'bottom'},
                scales: {
                    xAxes: [{
                        type: 'time',
                        time: {
                            tooltipFormat: 'DD.MM.YY',
                            displayFormats: {
                                month: 'MM.YY',
                                day: 'DD.MM.YY',
                            }
                        }
                    }]
                }
            },
            statCols: [
                {key: "phone", label: "Телефон", sortable: true},
                {key: "tracking_enabled", label: "", sortable: true},
                {key: "phone_name", label: "Название"},
                {key: "calls", label: "Звонки", sortable: true}
            ]
        }
    },
    created () {
        this.loadData();
    },
    watch: {
        '$route': 'loadData'
    },
    computed: {
        trackingCount () {
            if (!this.phones) {
                return 0;
            }
            return this.phones.filter(p => {
                return p.tracking_enabled;
            }).length;
        },
        chartData () {
            if (!this.phones || !this.stats) {
                return null;
            }
            var data = [];
            switch (this.chartType) {
                case 'phones':
                    data = this.phones.map(p => {
                        return {label: Utils.formatPhone(p.phone),
                                value: p.calls};
                    });
                    break;
                case 'call-tracking':
                    data = this.phones.filter(p => {
                        return p.tracking_enabled === true;
                    }).map(p => {
                        return {label: Utils.formatPhone(p.phone) +
                                       ` (${p.phone_name})`,
                                value: p.calls};
                    });
                    break;
                case 'call-tracking-share':
                    data = [
                        {'label': 'Другие номера',
                         value: this.stats.calls},
                        {'label': 'Call-tracking',
                         value: this.trackingCount}
                    ];
                    break;
            }
            return {
                labels: data.map(i => { return i.label; }),
                datasets: [{
                    data: data.map(i => { return i.value; }),
                    backgroundColor: chroma.scale('RdYlBu').colors(
                        data.length
                    )
                }]
            };
        },
        timeChartData () {
            if (!this.timeStat) {
                return null;
            }
            const datasets = {};

            var statData = [];
            switch (this.timeChartType) {
                case 'all':
                    var dates = {};
                    this.timeStat.forEach((row) => {
                        if (!Object.keys(dates).includes(row.day)) {
                            dates[row.day] = 0;
                        }
                        dates[row.day] += row.count;
                    });
                    for (const i in dates) {
                        statData.push({
                            key: 'all',
                            label: 'Звонки',
                            count: dates[i],
                            day: i
                        });
                    }
                    break;
                case 'phones':
                    statData = this.timeStat.map(p => {
                        p.key = p.phone;
                        p.label = Utils.formatPhone(p.phone);
                        return p;
                    });
                    break;
            }

            statData.forEach((row) => {
                if (!Object.keys(datasets).includes(row.key)) {
                    datasets[row.key] = {
                        label: row.label,
                        data: [],
                        fill: false,
                        spanGaps: true,
                    };
                }
                datasets[row.key].data.push({t: row.day, y: row.count});
            });
            const colors = chroma.scale('Set1').colors(
                Object.keys(datasets).length
            );

            return {
                datasets: Object.values(datasets).map((d, i) => {
                    d.borderColor = colors[i];
                    d.backgroundColor = chroma(colors[i]).alpha(0.5).hex();
                    return d;
                })
            };
        }
    },
    methods: {
        loadData () {
            this.loadStats();
            this.loadTimeStat();
        },
        async loadStats () {
            this.loading = true;
            try {
                const data = await Api.getStatisticsIncoming(
                    parseInt(this.projectId)
                );
                this.phones = data.phones;
                this.stats = data.stats;
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('Ошибка загрузки статистики', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            this.loading = false;
        },
        async loadTimeStat () {
            this.loadingTime = true;
            const query = {type: 'incoming', period: 'day'}
            try {
                this.timeStat = await Api.getStatisticsTime(
                    parseInt(this.projectId), query
                );
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('Ошибка загрузки статистики по датам', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            this.loadingTime = false;
        },
        formatRate (num) {
            return Math.round(num * 100) / 100;
        },
        ...Utils
    }
};

</script>
